import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'
import ImageInitial from 'src/assets/Home/image_initial.avif'
export const OverContainerSection = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
`
export const OverContainer = styled(Box)`
    background: url(${ImageInitial}) no-repeat center/cover;
    display: flex;
    justify-content: center;
    overflow: hidden;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
        justify-content: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: row;
        justify-content: center;
    }
`
export const OverSpan = styled.span`
    position: absolute;
    background-size: cover;
    background-position: center center;
    top: 0;
    left: 0;
    width: 100%;
    height: 98%;
    opacity: 0.8;
    background-color: ${({ theme }) => theme.colors.footerPrimary};
`

export const ContentTypography = styled(Box)`
    width: 100%;
    justify-content: space-around;
    align-items: center;
    display: flex;
    flex-direction: column;
    animation-name: zoomIn;
    animation-duration: 1s;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 95%;
        flex-direction: row;
        justify-content: start;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: row;
    }
`

export const TypographySectionDes = styled(Typography)`
    position: relative;
    float: left;
    font-family: inherit;
    text-align: center;
    font-style: normal;
    margin-top: 10px;
    line-height: 27px;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 26px;
        text-align: start;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 36px;
    }
`

export const TypographySection = styled(Typography)`
    position: relative;
    float: left;
    font-family: inherit;
    text-align: center;
    font-style: normal;
    line-height: 32px;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 36px;
        text-align: start;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 46px;
    }
`
export const BoxContain = styled(motion(Box))`
    width: 90%;
    display: flex;
    height: 200px;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 50%;
        flex-direction: column;
        align-items: start;
        height: 250px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 600px;
        height: 300px;
    }
`

export const BoxForm = styled(motion(Box))`
    width: 93%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 50%;
        margin-left: 40px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 500px;
        margin-left: 0;
    }
`

export const ButtonSection = styled(Box)`
    width: 167px;
    height: 37.33px;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 35.33px;
        width: 177px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 37.33px;
        width: 177px;
    }
`
